var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0014 14.0005L12.0014 10.0005M12.0014 10.0005L8.00143 14.0005M12.0014 10.0005V19.0005M20.3914 16.3905C21.3668 15.8587 22.1373 15.0174 22.5813 13.9991C23.0253 12.9808 23.1176 11.8437 22.8436 10.7672C22.5696 9.69062 21.9449 8.73598 21.0681 8.05392C20.1913 7.37185 19.1123 7.00121 18.0014 7.00047H16.7414C16.4387 5.82971 15.8746 4.74281 15.0914 3.82147C14.3082 2.90012 13.3263 2.16832 12.2195 1.68108C11.1128 1.19384 9.90998 0.963831 8.70154 1.00835C7.49311 1.05288 6.31049 1.37077 5.2426 1.93814C4.17471 2.5055 3.24934 3.30758 2.53605 4.28405C1.82276 5.26053 1.34012 6.38601 1.1244 7.57587C0.908695 8.76572 0.96553 9.989 1.29064 11.1537C1.61575 12.3185 2.20067 13.3943 3.00143 14.3005",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/ButtonIcon.7653c760c5e35837d8b1363134adc0d4.svg";
export { ForwardRef as ReactComponent };